import { handleDeleteConfirmation } from "Utils/handleDelete";
import {
	fetchTentors,
	deleteTentor,
} from "Features/Classes/Tentor/Utils/TentorUtils";
import Swal from "sweetalert2";

/* **************************************************** */
/* CRUD Tentor                                          */
/* **************************************************** */

export const fetchTentor = (dispatch, filters, refetch) => {
	dispatch(fetchTentors(filters));
};

export const handleGetDetailTentor = async (dispatch, item, setDetail) => {
	dispatch(setDetail(item));
};

export const handleDeleteTentor = async (dispatch, id, setRefetch) => {
	handleDeleteConfirmation({
		dispatch,
		id,
		setRefetch,
		deleteAction: deleteTentor,
	});
};

export const handleEditTentor = async (dispatch, item, setField) => {
	const fieldsToUpdate = ["name", "phone", "mastered_fields", "status", "email"];
	fieldsToUpdate.forEach((field) => {
		dispatch(setField({ field, value: item[field] }));
	});
	dispatch(setField({ field: "photo_url", value: item.photo }));
	dispatch(setField({ field: "education", value: item.education }));
	dispatch(setField({ field: "experience", value: item.experience }));
	dispatch(setField({ field: "isUpdate", value: true }));
	dispatch(setField({ field: "id", value: item.id }));
};

export const handleCopy = (id) => {
	const link = document.createElement("textarea");
	link.value = `${process.env.REACT_APP_USER_URL}/mentors#${id}`;
	document.body.appendChild(link);
	link.select();

	try {
		document.execCommand("copy");
		Swal.fire({
			title: "Copied!",
			text: "Link profile berhasil dicopy",
			icon: "success",
			confirmButtonColor: '#3085d6',
		});
	} catch (err) {
		Swal.fire({
			title: "Error!",
			text: "Gagal menyalin link profile",
			icon: "error",
			confirmButtonColor: '#3085d6',
		});
	}
	document.body.removeChild(link);
};

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (
	pagination,
	filters,
	dispatch,
	setFilters,
	setRefetch
) => {
	if (pagination.current_page > 1) {
		dispatch(
			setFilters({
				...filters,
				page: pagination.current_page - 1,
			})
		);
		setRefetch((prevRefetch) => !prevRefetch);
	}
};

export const handleNextPagination = (
	pagination,
	filters,
	dispatch,
	setFilters,
	setRefetch
) => {
	if (pagination.current_page < pagination.total) {
		dispatch(
			setFilters({
				...filters,
				page: pagination.current_page + 1,
			})
		);
		setRefetch((prevRefetch) => !prevRefetch);
	}
};

export const handleClickPagination = (
	page,
	filters,
	dispatch,
	setFilters,
	setRefetch
) => {
	dispatch(
		setFilters({
			...filters,
			page: page,
		})
	);
	setRefetch((prevRefetch) => !prevRefetch);
};
